export default "assets/note-781f411e.jpg";